import { render, staticRenderFns } from "./CRUD.vue?vue&type=template&id=0bb17e24"
import script from "./CRUD.vue?vue&type=script&lang=js"
export * from "./CRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports